<div>
  <mat-card-title mat-dialog-title class="d-flex align-items-center mb-0">
    <mat-icon class="mr-2">{{ data.icon || 'description' }}</mat-icon>
    <div class="title">{{ data.title }}</div>
  </mat-card-title>
  <mat-card-subtitle>{{ data.subtitle }}</mat-card-subtitle>
</div>
<mat-divider></mat-divider>

<mat-dialog-content>
  <div class="col-sm-12 mt-2">
    <form [formGroup]="shareFormGroup">
      <!--Additional Email Field-->
      <mat-form-field
        style="width: '100%'"
        appearance="fill"
        class="ref-fields-form-field"
      >
        <mat-label>
          {{ 'shared.send-request-popup.additional-emails' | translate }}
        </mat-label>
        <mat-chip-grid #emailsChipList>
          <mat-chip
            *ngFor="let email of addedEmails"
            [selectable]="false"
            (removed)="removeEmail(email)"
          >
            {{ email }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            placeholder="{{
              'shared.send-request-popup.additional-emails-placeholder'
                | translate
            }}"
            #emailInput
            formControlName="additionalEmail"
            [matChipInputFor]="emailsChipList"
            [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="
              addEmail(emailInput.value); emailInput.value = ''
            "
          />
        </mat-chip-grid>
        <mat-error
          *ngIf="
            shareFormGroup.controls.additionalEmail.hasError('email') ||
            emailValidationError
          "
        >
          {{
            'shared.send-request-popup.additional-emails.pattern-error'
              | translate
          }}
        </mat-error>
      </mat-form-field>

      <!-- remarks -->
      <mat-form-field appearance="fill" style="width: '100%'">
        <mat-label>{{
          'shared.send-request-popup.remarks' | translate
        }}</mat-label>
        <textarea
          data-testid="step-documents-description"
          type="text"
          matInput
          formControlName="remarks"
        ></textarea>
      </mat-form-field>

      <div
        class="row"
        *ngFor="let contactDetail of contactDetails; let i = index"
      >
        <div class="col-1 d-flex align-items-center justify-content-center">
          <p class="d-flex align-items-center justify-content-center">
            <mat-checkbox
              [checked]="contactDetail.isSelect"
              (change)="update($event.checked, i)"
            ></mat-checkbox>
          </p>
        </div>
        <el-multi-field
          appearance="fill"
          class="col-11 pl-0"
          title="{{ contactDetail.details.type === 'EMAIL' ? 'Email' : 'SMS' }}"
          placeholder="{{
            contactDetail.details.type === 'EMAIL'
              ? 'johndoe@example.com'
              : '011234567'
          }}"
          [data]="contactDetail.details"
        ></el-multi-field>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="m-2">
    <button
      (click)="onClickCancel()"
      class="m-2"
      [color]="'primary'"
      mat-button
    >
      {{ 'shared.remarks-popup.cancel' | translate }}
    </button>
    <button
      mat-raised-button
      class="m-2"
      [color]="'primary'"
      [disabled]="checkDisability()"
      (click)="onClickShare()"
    >
      {{ 'shared.remarks-popup.share' | translate }}
    </button>
  </div>
</mat-dialog-actions>
